import { Web3Provider } from "@ethersproject/providers";
import { useWeb3React, UnsupportedChainIdError } from "@web3-react/core";
import { useEffect, useState } from "react";

export function useCheckNetwork() {
  const context = useWeb3React<Web3Provider>();
  const [correctNetwork, setCorrectNetwork] = useState("");
  const [connected, setConnected] = useState(false);

  const { account, error } = context;
  useEffect(() => {
    if (account) {
      setConnected(true);
    }
    if (!account) {
      setConnected(false);
    }
    if (error) {
      setCorrectNetwork(
        error instanceof UnsupportedChainIdError ? "SWITCH TO POLYGON" : "ERROR"
      );
      console.error(error);
      console.log(error instanceof UnsupportedChainIdError);
    }
    if (!error) {
      setCorrectNetwork("");
    }
  }, [account, error]);
  return { connected, correctNetwork };
}
